<style scoped>
tr:nth-child(odd) {
  background: #f6f6f6;
}
.v-card__text {
  padding: 0;
}
</style>
<template>
  <v-container>
    <v-layout row wrap mt-5 pb-3>
      <v-flex xs12>
        <h3>
          <v-icon large color="yellow">book</v-icon>
          Address Book
        </h3>
        Here you can change/add your addresses.
        <blockquote>
          Please use the edit or add buttons to configure your addresses.
        </blockquote>
      </v-flex>
    </v-layout>
    <v-tabs class="elevation-3">
      <v-tab>Delivery Address</v-tab>
      <v-tab-item>
        <v-card flat>
          <v-card-text>
            <address-list
              collection="shipTos"
              :items="shipTos"
              deletable
              editable
              :allowAddAdress="canAddShipTo"
            ></address-list>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab v-if="isWithEndCustomer">End Customer Address</v-tab>
      <v-tab-item v-if="isWithEndCustomer">
        <v-card flat>
          <v-card-text>
            <address-list
              collection="endCustomers"
              :items="endCustomers"
              deletable
              editable
            ></address-list>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import AddressList from "@/components/AddressList.vue";

export default {
  components: {
    AddressList
  },
  computed: {
    ...mapGetters("customer", {
      endCustomers: "getEndCustomers",
      shipTos: "getShipTos",
      canAddShipTo: "canAddShipTo",
      isWithEndCustomer: "isWithEndCustomer"
    })
  }
};
</script>
